import { FormFieldKey } from 'src/app/@shared/form/form.types';

export type DetailFieldsetKey = 'meta' | 'topics' | 'contact' | 'contactPersons' | 'organization-co-information' | 'additionalInformation';

export type DetailFieldsetConfig = {
  id: DetailFieldsetKey;
  title: string;
  // Omit fieldIds to include every field not explicitly assigned to another detail fieldset.
  fieldIds?: FormFieldKey[];
};

// Detail section and field order is independent of FORM_FIELDSET_CONFIG used by edit forms.
export const DETAIL_FIELDSET_CONFIG: DetailFieldsetConfig[] = [
  {
    fieldIds: [
      'legacyId',
      'type',
      'subType',
      'subTypeForm',
      'searchForms',
      'status',
      'isPublished',
    ],
    id: 'meta',
    title: '',
  },
  {
    fieldIds: [
      'name',
      'shortName',
      'contactViaNakos',
      'addressCo',
      'addressStreetAndNumber',
      'addressPostalCode',
      'addressCity',
      'addressFederalState',
      'phoneContacts',
      'emails',
      'emailsExtended',
      'phoneNumbers',
      'websites',
      'socialMediaLinks',
    ],
    id: 'contact',
    title: 'FORM.LIST.TITLE.CONTACT',
  },
  {
    fieldIds: ['contactPersons'],
    id: 'contactPersons',
    title: 'FORM.LIST.TITLE.CONTACT_PERSONS',
  },
  {
    // Its fields come from the selected c/o relation, rather than the current dataset.
    fieldIds: [],
    id: 'organization-co-information',
    title: 'FORM.LIST.TITLE.CO_INFORMATION',
  },
  {
    fieldIds: ['topics', 'additionalTopics'],
    id: 'topics',
    title: 'FORM.LIST.TITLE.TOPICS',
  },
  {
    id: 'additionalInformation',
    title: 'FORM.LIST.TITLE.ADDITIONAL_INFORMATION',
  },
];
